import React from 'react';

type ArrowDownIconPropsType = React.SVGProps<SVGSVGElement>;

export const BookOutlinedIcon: React.FC<ArrowDownIconPropsType> = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3327 13.9501V3.89174C18.3327 2.89174 17.516 2.15008 16.5243 2.23341H16.4743C14.7243 2.38341 12.066 3.27508 10.5827 4.20841L10.441 4.30008C10.1993 4.45008 9.79935 4.45008 9.55768 4.30008L9.34935 4.17508C7.86602 3.25008 5.21602 2.36674 3.46602 2.22508C2.47435 2.14174 1.66602 2.89174 1.66602 3.88341V13.9501C1.66602 14.7501 2.31602 15.5001 3.11602 15.6001L3.35768 15.6334C5.16602 15.8751 7.95768 16.7917 9.55768 17.6667L9.59102 17.6834C9.81602 17.8084 10.1743 17.8084 10.391 17.6834C11.991 16.8001 14.791 15.8751 16.6077 15.6334L16.8827 15.6001C17.6827 15.5001 18.3327 14.7501 18.3327 13.9501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.57422V17.0742"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.45898 7.07422H4.58398"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08398 9.57422H4.58398"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
